import React, { useState, useEffect } from "react";
import Footer from "../../../components/footerPage/Footer";
import AllHeader from "../../../components/Navbar/AllHeader";
import BodyYacht from "./components/BodyYacht";
import Sail from "../../../Asset/image/yacht/Sail.gif"; // loader gif
import SEO from "../../../components/SEO/SEO";

function Yacht() {
  const [loading, setLoading] = useState(true);
  const [showScrollTop, setShowScrollTop] = useState(false);
  const selectedLanguage = localStorage.getItem("selectedLanguage");

  useEffect(() => {
    const handleScroll = () => {
      setShowScrollTop(window.scrollY > 300);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    // จำลองโหลดข้อมูล (หรือค้างโหลดเหมือน PersonalInformation)
    const timer = setTimeout(() => {
      setLoading(false);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const isEN = selectedLanguage === "en";

  return (
    <>
      {!loading && (
        <SEO
          title={
            isEN
              ? "Yacht Charter in Thailand - Explore Luxury Yachts | Take My Yacht"
              : "เช่าเรือยอชต์ในประเทศไทย - รวมเรือยอชต์สุดหรู | Take My Yacht"
          }
          description={
            isEN
              ? "Explore a wide selection of luxury yachts available for charter across Thailand. Choose from various sizes, routes, and private charter experiences with professional crew."
              : "สำรวจเรือยอชต์สุดหรูหลากหลายประเภทสำหรับเช่าในประเทศไทย เลือกได้ทั้งขนาด เส้นทาง และประสบการณ์เหมาลำส่วนตัว พร้อมลูกเรือมืออาชีพ"
          }
          url="https://takemyyacht.com/yacht"
          schema={{
            "@context": "https://schema.org",
            "@type": "CollectionPage",
            name: isEN
              ? "Yacht Charter in Thailand"
              : "เช่าเรือยอชต์ในประเทศไทย",
            description: isEN
              ? "A curated collection of luxury yachts available for private charter across Thailand."
              : "รวมเรือยอชต์สุดหรูสำหรับการเช่าเหมาลำส่วนตัวทั่วประเทศไทย",
          }}
        />
      )}

      {loading && (
        <div
          className="modal-overlay2"
        >
          <img
            src={Sail}
            alt="Loading..."
            className="modal-image"
            draggable={false}
          />
        </div>
      )}

      <div style={{ opacity: loading ? 0.5 : 1 }}>
        <AllHeader />
        <BodyYacht />
        <Footer />
      </div>

      {showScrollTop && (
        <button
          onClick={scrollToTop}
          aria-label="Scroll to top"
          className="scroll-to-top-btn"
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = "translateY(-4px)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = "translateY(0)";
          }}
        >
          {/* Chevron Up */}
          <svg
            width="26"
            height="26"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <polyline points="18 15 12 9 6 15" />
          </svg>
        </button>
      )}
    </>
  );
}

export default Yacht;
